import React, { useCallback, useEffect } from 'react'
import { Box } from '@usap/uicomponents'
import paymentConfig from '../../../../../../config/payment-config'
import useWmoEnabled from '../../../../../hooks/useWmoEnabled'
import ZipPaymentWmo from './ZipPaymentWmo'

const ZIP_PAY = paymentConfig.ZIP_SDK_URL
const ZIP_MERCHANT_ID = paymentConfig.ZIP.merchantId

const ZipPayment = props => {
  const isWmoEnabled = useWmoEnabled()
  const { totalAfterTax } = props

  const styleCSS = {
    zip: {
      color: '#333333',
      width: '100%',
      height: '23px',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '.25px',
      marginBottom: '8px',
    },
  }

  const injectScript = useCallback(
    () => {
      const script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.setAttribute('src', ZIP_PAY)
      script.setAttribute('async', true)
      document.head.appendChild(script)
    },
    [],
  )

  useEffect(() => {
    if (__BROWSER__ && window && !window.quadpay) {
      injectScript()
    }
  }, [injectScript])

  if (isWmoEnabled) {
    return <ZipPaymentWmo totalAfterTax={totalAfterTax} />
  }

  return (
    <Box style={styleCSS.zip}>
      <quadpay-widget-v3
        merchantId={`${ZIP_MERCHANT_ID}`}
        amount={totalAfterTax}
        logoOption="secondary-light"
        max="3000"
        min="35"
        currency="USD"
      />
    </Box>
  )
}

export default ZipPayment
